var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getOrderNumber !== '')?_c('div',{staticClass:"details-container"},[_c('details-header'),_c('details-status'),(_vm.getCanSendSMS && !_vm.getIsFinishedStatus)?_c('details-phone'):_vm._e(),_c('details-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }